import { BookOpen, Home, User } from "lucide-react";
import { NavLink } from "react-router-dom";

/** Основная навигация после онбординга — три вкладки из ТЗ. */
const TABS = [
  { to: "/", Icon: Home, label: "Главная", end: true },
  { to: "/articles", Icon: BookOpen, label: "Статьи", end: false },
  { to: "/profile", Icon: User, label: "Профиль", end: false },
] as const;

export function TabBar() {
  return (
    <nav className="tabbar">
      {TABS.map(({ to, Icon, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => `tabbar__item${isActive ? " tabbar__item--active" : ""}`}
        >
          <Icon size={22} strokeWidth={1.8} aria-hidden />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
